module.exports = __webpack_public_path__ + "img/lr1.79710646.png";